import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import { LinkListComponent } from './link-list/link-list.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [LayoutComponent, LinkListComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
  ],
  exports: [LayoutComponent],
})
export class LayoutModule { }
